module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Carolly Erickson\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Distinguished historian "), _c('B', [_vm._v("Carolly Erickson")]), _vm._v(" is the author of "), _c('I', [_vm._v("Rival to the Queen")]), _vm._v(", "), _c('I', [_vm._v("The Memoirs of Mary Queen of Scots")]), _vm._v(", "), _c('I', [_vm._v("The First Elizabeth")]), _vm._v(", "), _c('I', [_vm._v("The Hidden Life of Josephine")]), _vm._v(", "), _c('I', [_vm._v("The Last Wife of Henry VIII,")]), _vm._v(" and many other prize-winning works of fiction and nonfiction. Her novel "), _c('I', [_vm._v("The Tsarina's Daughter")]), _vm._v(" won the "), _c('I', [_vm._v("Romantic Times")]), _vm._v(" Reviewer's Choice Award for Best Historical Fiction. She lives in Hawaii.")], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/1CvgtjI/tc-custom/9781429904056.jpg?1730776558773",
      "alt": "This image is the cover for the book To The Scaffold"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("To The Scaffold\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("One of history's most misunderstood figures, Marie Antoinette represents the extravagance and the decadence of pre-Revolution France. Yet there was an innocence about Antoinette, thrust as a child into the chillingly formal French court."), _c('br'), _c('br'), _vm._v("Married to the maladroit, ill-mannered Dauphin, Antoinette found pleasure in costly entertainments and garments. She spent lavishly while her overtaxed and increasingly hostile subjects blamed her for France's plight. In time Antoinette matured into a courageous Queen, and when their enemies finally closed in, Antoinette followed her inept husband to the guillotine in one last act of bravery."), _c('br'), _c('br'), _vm._v("In "), _c('i', [_vm._v("To the Scaffold")]), _vm._v(", Carolly Erickson provides an estimation of a lost Queen that is psychologically acute, richly detailed, and deeply moving.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0